import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { ArcadeButton, spacing, Stack, Text } from '@cash-design-system/react'
import { useQueryGetCustomerGatewayBalances } from '@cash-web/shared-data-access-api/react-query'
import { useMutationConfirmPayment } from '@cash-web/shared-data-access-api/react-query/useMutationConfirmPayment'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'

import { BlockerConfirmProps } from './BlockerConfirm'

const StyledHeader = styled(Text)`
  margin: ${({ theme: { spacing } }) => `${spacing.m} ${spacing.empty}`};
`
const ButtonsWrapper = styled.div`
  margin-bottom: ${({ theme: { spacing } }) => spacing.m};
  display: flex;
  justify-content: space-between;
  gap: ${spacing.l};
`
export function ConfirmPayment({ supplement, blocker }: BlockerConfirmProps) {
  const { t } = useTranslation()
  const flow = useFlowContext()
  const { mutateAsync: confirmPayment, isLoading } = useMutationConfirmPayment()
  const handleSubmit = async () => {
    flow.updateWithResponse({
      response: confirmPayment({
        payment_tokens: flow.active?.paymentTokens,
      }),
      queriesToInvalidate: ['account-activities', useQueryGetCustomerGatewayBalances.rootQueryKey],
    })
  }

  return (
    <Stack space={spacing.m}>
      {supplement?.main_text && (
        <StyledHeader typography="numeralSmall" as="h2" color="textStandard">
          {supplement.main_text}
        </StyledHeader>
      )}
      <ButtonsWrapper>
        <ArcadeButton size="cta" prominence="prominent" isLoading={isLoading} onClick={handleSubmit}>
          {t('Confirm', { context: 'confirm button in modal' })}
        </ArcadeButton>
      </ButtonsWrapper>
    </Stack>
  )
}
